import { withDependencies } from '@wix/thunderbolt-ioc'
import { IPinnedExternalIdStore } from '../types'

export const PinnedExternalIdStore = withDependencies(
	[],
	(): IPinnedExternalIdStore => {
		// external id can be undefined before the site is saved, pinning should preserve this state as well
		const pinnedExternalIds: { [compId: string]: string | undefined } = {}
		return {
			getPinnedExternalId(compId: string) {
				return pinnedExternalIds[compId]
			},
			pinExternalId(compId: string, externalId: string | undefined) {
				if (!(compId in pinnedExternalIds)) {
					pinnedExternalIds[compId] = externalId
				}
			},
			hasPinnedExternalId(compId: string) {
				return compId in pinnedExternalIds
			},
			unpinExternalId(compId: string) {
				delete pinnedExternalIds[compId]
			},
		}
	}
)
